(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Función global para abrir el cart-drawer
  
  
  function closeCartDrawer() {
    const selectors = [
      'cart-drawer',
      '#CartDrawer', 
      '.cart-drawer',
      '[data-cart-drawer]'
    ];
    
    let cartDrawer = null;
    for (let selector of selectors) {
      cartDrawer = document.querySelector(selector);
      if (cartDrawer) break;
    }
    
    if (cartDrawer) {
      cartDrawer.classList.remove('active', 'open', 'show');
      cartDrawer.style.display = 'none';
      cartDrawer.removeAttribute('open');
    }
    
    const overlay = document.querySelector('.cart-drawer-overlay, .drawer-overlay');
    if (overlay) overlay.style.display = 'none';
  }

  

  // Custom element para manejar el botón del carrito

  customElements.define('sticky-header', StickyHeader);
  customElements.define('cart-drawer-button', CartDrawerButton);

  } catch(e) { console.error(e); }
})();
})();
